import { useEffect, useState } from "react";
import { useQuery } from "react-query";
//services
import { getTeam } from "../services/GlobalRoles/getTeam";
import { getLands } from "../services/GlobalRoles/getLands";
import { getTeams } from "../services/GlobalRoles/getTeams";
import { getOwner } from "../services/GlobalRoles/getOwner";
import { getUsers } from "../services/GeneralRegistration/getUsers";
import { getBlocks } from "../services/GlobalRoles/getBlocks";
import { getAccount } from "../services/GlobalRoles/getAccount";
import { getSuppliers } from "../services/Financial/AccountToPay/getSuppliers";
import { getEnterprise } from "../services/GlobalRoles/getEnterprise";
import { getAccountants } from "../services/GlobalRoles/getAccountants";
import { getPaymentMethods } from "../services/Settings/PaymentMethods/getPaymentMethods";
import { getParcelDescription } from "../services/GlobalRoles/getParcelDescription";
//contexts
import { useAppContext } from "../context/AppContext";

export function useOptionsSelect(registrationType) {
  const { permissions } = useAppContext();
  const [client, setClient] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [enterprise, setEnterprise] = useState([]);
  const [isLoadingEnterprises, setIsLoadingEnterprises] = useState(true);
  const [isLoadingClients, setIsLoadingClients] = useState(true);
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(true);

  const [blocks, setBlocks] = useState([]);
  const [isLoadingBlocks, setIsLoadingBlocks] = useState(false);

  const [lands, setLands] = useState(null);
  const [isLoadingLands, setIsLoadingLands] = useState(false);

  const [team, setTeam] = useState(null);
  const [isLoadingTeams, setIsLoadingTeams] = useState(true);

  const [members, setMembers] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);

  const [imobs, setImob] = useState([]);
  const [isLoadingImobs, setIsLoadingImobs] = useState(false);

  const [brokers, setBrokes] = useState([]);
  const [isLoadingBroker, setIsLoadingBroker] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState(null);
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false);

  const [currentAccount, setCurrentAccount] = useState(null);
  const [loadingCurrentAccount, setLoadingCurrentAccount] = useState(false);

  const [ownersOptions, setOwnersOptions] = useState([]);
  const [parcelOptions, setParcelOptions] = useState([]);
  const [accountantsOptions, setAccountantsOptions] = useState([]);

  const typePeriodOptions = [
    { label: "Lançamento", value: 1 },
    { label: "Vencimento", value: 2 },
    { label: "Recebimento", value: 3 },
    { label: "Baixa", value: 4 },
  ];

  const status = [
    { label: "Em Aberto", value: 0 },
    { label: "Pago", value: 1 },
  ];

  const dataClients = {
    registration_type_id: registrationType ? registrationType : 1,
  };

  const { data: clients } = useQuery("clients", () => getUsers(dataClients), {
    onSuccess: () => setIsLoadingClients(false),
    retry: false,
    enabled: !!permissions?.includes("10"),
  });

  const { data: enterprises } = useQuery({
    queryKey: ["enterprise"],
    queryFn: () => getEnterprise(),
    onSuccess: () => setIsLoadingEnterprises(false),
    retry: false,
    enabled: !!permissions?.includes("13"),
  });

  const { data: suppliers } = useQuery({
    queryKey: ["supplier"],
    queryFn: async () => getSuppliers(),
    onSuccess: () => setIsLoadingSuppliers(false),
    retry: false,
    enabled: !!permissions?.includes("13"),
  });

  const { data: teams } = useQuery("teams", () => getTeams(), {
    onSuccess: () => setIsLoadingTeams(false),
    retry: false,
    enabled: !!permissions?.includes("101"),
  });

  const { data: paymentMethods } = useQuery(
    "payment-methods",
    () => getPaymentMethods(),
    {
      onSuccess: () => setLoadingPaymentMethods(false),
      retry: false,
      enabled: !!permissions?.includes("156"),
    }
  );

  const { data: currentAccounts } = useQuery(
    "current-account",
    () => getAccount(),
    {
      onSuccess: () => setLoadingCurrentAccount(false),
      retry: false,
      enabled: !!permissions?.includes("145"),
    }
  );

  const { data: owners, isLoading: loadingOwners } = useQuery(
    "owners",
    () => getOwner(),
    {
      retry: false,
    }
  );

  const { data: accountants, isLoading: loadingAccountants } = useQuery(
    "accountants",
    () => getAccountants(),
    {
      retry: false,
    }
  );

  const { data: parcelDescriptions, isLoading: loadingParcelDescriptions } =
    useQuery("parcel-desccriptions", () => getParcelDescription(), {
      retry: false,
      enabled: !!permissions?.includes("140"),
    });

  const selectEnterprise = async (enterpriseId) => {
    if (enterpriseId) {
      setIsLoadingBlocks(true);
      const response = await getBlocks(enterpriseId);

      const data = Object.keys(response).map((index) => {
        const dado = response[index];
        return {
          value: dado.id,
          label: dado.name,
        };
      });

      data.sort((a, b) => a.label.localeCompare(b.label));
      setBlocks(data);
      setIsLoadingBlocks(false);
    }
  };

  const selectBlock = async (e) => {
    if (e) {
      setIsLoadingLands(true);
      const response = await getLands(e);
      const refactorResponse = response.map((l) => {
        return {
          value: l.id,
          label: l.name,
        };
      });
      if (refactorResponse) {
        setLands(refactorResponse);
        setIsLoadingLands(false);
      }
    }
  };

  const selectTeam = async (t) => {
    if (t) {
      setLoadingMembers(true);
      setIsLoadingImobs(true);
      setIsLoadingBroker(true);
      const data = await getTeam(t);
      const refactorResponse = data.members.map((l) => {
        return {
          value: l.id,
          label: l.name,
        };
      });
      if (refactorResponse) {
        setMembers(refactorResponse);
        setLoadingMembers(false);
      }

      const imobiliariasFiltered = data.members.filter((member) =>
        member.registration_types.some(
          (registration) => registration.name === "Imobiliária"
        )
      );

      const corretoresFiltered = data.members.filter((member) =>
        member.registration_types.some(
          (registration) => registration.name === "Corretor"
        )
      );

      if (imobiliariasFiltered) {
        const imobMembers = imobiliariasFiltered.map((i) => ({
          value: i.id,
          label: i.name,
        }));
        setImob(imobMembers);
      }
      setIsLoadingImobs(false);

      if (corretoresFiltered) {
        const sellerMembers = corretoresFiltered.map((i) => ({
          value: i.id,
          label: i.name,
        }));
        setBrokes(sellerMembers);
      }
      setIsLoadingBroker(false);
    }
  };

  useEffect(() => {
    if (clients) {
      const mappedClients = clients.map((c) => ({
        value: c.id,
        label: c.name,
      }));
      setClient(mappedClients);
    }
  }, [clients]);

  useEffect(() => {
    if (enterprises) {
      const mappedEnterprises = enterprises.map((item) => ({
        label: item.title,
        value: item.id,
      }));
      setEnterprise(mappedEnterprises);
    }
  }, [enterprises]);

  useEffect(() => {
    if (suppliers) {
      const mappedSuppliers = suppliers.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setSupplier(mappedSuppliers);
    }
  }, [suppliers]);

  useEffect(() => {
    if (teams) {
      setTeam(
        teams.map((t) => ({
          value: t.id,
          label: t.name,
        }))
      );
    }
  }, [teams]);

  useEffect(() => {
    if (paymentMethods) {
      setPaymentMethod(
        paymentMethods?.map((t) => ({
          value: t.id,
          label: t.name,
        }))
      );
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (currentAccounts) {
      setCurrentAccount(
        currentAccounts?.map((t) => ({
          value: t.id,
          label: `${t.name_bank} - Ag: ${t.agency}-${t.agency_digit} / Cc: ${t.account_number}-${t.account_digit}`,
        }))
      );
    }
  }, [currentAccounts]);

  useEffect(() => {
    if (owners) {
      setOwnersOptions(
        owners.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      );
    }
  }, [owners]);

  useEffect(() => {
    if (parcelDescriptions) {
      setParcelOptions(
        parcelDescriptions.map((item) => ({
          value: item.id,
          name: item.description,
        }))
      );
    }
  }, [parcelDescriptions]);

  useEffect(() => {
    if (accountants) {
      setAccountantsOptions(
        accountants.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      );
    }
  }, [accountants]);

  return {
    team,
    lands,
    imobs,
    client,
    status,
    blocks,
    brokers,
    members,
    supplier,
    selectTeam,
    enterprise,
    accountants,
    selectBlock,
    paymentMethod,
    ownersOptions,
    loadingOwners,
    parcelOptions,
    isLoadingLands,
    isLoadingTeams,
    isLoadingImobs,
    loadingMembers,
    currentAccount,
    isLoadingBroker,
    isLoadingBlocks,
    isLoadingClients,
    selectEnterprise,
    typePeriodOptions,
    loadingAccountants,
    accountantsOptions,
    isLoadingEnterprises,
    loadingPaymentMethods,
    loadingCurrentAccount,
    loadingParcelDescriptions,
  };
}
